<app-loading *ngIf="isLoading$ | async" [options]="(loadingOpts$ | async) ?? undefined" />

<!--Desktop Nav-->
<ng-container *ngIf="!(isMobile$ | async)">
  <app-desktop-nav />
</ng-container>
<!--Desktop Nav-->

<!--Mobile Nav-->
<ng-container *ngIf="isMobile$ | async">
  <app-mobile-nav />
</ng-container>
<!--Mobile Nav-->
